export default "/_next/static/1df77906554c775cec35f3b1cf1ec92e.png";